export default {
    inventory(state)
    {
        return state.inventory
    },
}
